import { getServerRequest, putServerRequest, postServerRequest} from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const getExpedientes = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expedientes`;
    return await getServerRequest(url, config);
}

export const expedientesVencidos = async (unidadAdministrativa,serie,subserie,page,search) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expedientesVencidos/${serie}/${subserie}/${unidadAdministrativa}?page=${page}&search=${search}`;
    return await getServerRequest(url, config);
}

export const guardarCajaService = async(data, expediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    let url = `${httpURL}/caja`;
    if(expediente) url = `${httpURL}/caja/${expediente}`;
    return await putServerRequest(url, data, config);
}

export const addToBoxService = async(caja,expediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/caja/${caja}/${expediente}`;
    return await putServerRequest(url,{}, config);
}

export const getCajasService = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/cajas`;
    return await getServerRequest(url, config);
}

export const getCajaExpediente = async (expediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/caja/expediente/${expediente}`;
    return await getServerRequest(url, config);
}

export const buscarExpedientesService = async (search) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expedientesCajas`;
    return await postServerRequest(url,{search}, config);

}
export const getOficoPadre = async (idExpediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expediente/oficioPadre/${idExpediente}`;
    return await getServerRequest(url, config);
}


